import { useEffect, useState } from 'react';

import { MicAnalyserProps } from '../types';

const MicAnalyser: React.FC<MicAnalyserProps> = ({ call }) => {
    const [volume, setVolume] = useState(0);

    useEffect(() => {
        const updateVolume = (volume: number) => setVolume(volume);
        call?.on('volume', updateVolume);

        return () => {
            call?.off('volume', updateVolume);
        };
    }, [call]);

    const barWidth = volume * 100;

    return (
        <div className="flex w-2 h-10 overflow-hidden bg-transparent border border-white/20 rounded-full">
            <div className="bg-white w-2 mt-auto rounded-full" style={{ height: `${barWidth}%` }} />
        </div>
    );
};
export default MicAnalyser;
